document.documentElement.classList.remove('no-js');

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form || !window.fetch) return;

  const button = event.submitter || form.querySelector('[type="submit"]');
  if (!button || button.disabled) return;

  event.preventDefault();
  const isBuyNow = button.hasAttribute('data-buy-now');
  const original = button.textContent;
  button.disabled = true;
  button.textContent = isBuyNow ? 'Opening checkout…' : 'Adding…';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to add item');

    const item = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      const current = Number(el.textContent || 0);
      el.textContent = current + (item.quantity || 1);
    });

    if (isBuyNow) {
      window.location.assign('/checkout');
      return;
    }

    const toast = document.getElementById('CartToast');
    if (toast) {
      toast.classList.add('is-visible');
      setTimeout(() => toast.classList.remove('is-visible'), 2200);
    }
    button.textContent = 'Added ✓';
    setTimeout(() => {
      button.textContent = original;
      button.disabled = false;
    }, 1200);
  } catch (error) {
    button.textContent = 'Try again';
    button.disabled = false;
  }
});

document.addEventListener('click', (event) => {
  const target = event.target.closest('[data-scroll-to-buy]');
  if (target) {
    event.preventDefault();
    document.querySelector('#buy')?.scrollIntoView({ behavior: 'smooth' });
  }
});

(() => {
  const modal = document.querySelector('[data-shipping-modal]');
  if (!modal) return;

  const dialog = modal.querySelector('.shipping-modal__dialog');
  let lastFocused = null;

  const openModal = () => {
    lastFocused = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('modal-open');
    requestAnimationFrame(() => modal.classList.add('is-open'));
    dialog?.focus();
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    document.body.classList.remove('modal-open');
    window.setTimeout(() => {
      modal.hidden = true;
      lastFocused?.focus?.();
    }, 180);
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-shipping-open]')) openModal();
    if (event.target.closest('[data-shipping-close]')) closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });
})();
